<style lang="stylus">
    .QRCode-mask
        modal-mask()
        .QRCode-modal
            width 577px
            .QRCode-container
                height 260px
                .QRCode-box
                    position relative
                    float left
                    .QRCode-title
                        height 18px
                        font-size 12px
                        margin-bottom 10px
                        color var(--text-color-primary)
                    &:nth-child(-n+2)
                        margin-bottom 15px
                    .QRCode-count
                        font-size: 12px
                        position absolute
                        right 18px
                        bottom 7px
                        color var(--text-color-tertiary)
                .QRCode-logbox
                    width 74%
                    .QRCode-inputArea
                        textarea
                            resize none
                            width 379px
                            height 142px
                            border: 1px solid $box-bordercolor;
                            border-radius: $box-radius;
                            color: var(--text-color-ivu-dropdown-item)
                    .QRCode-inputbox
                        width 50%
                        float left
                        .ivu-input-number-handler-wrap, .ivu-input-number-input
                            background-color var(--bg-color-tertiary)
                        .QRCode-selector
                            width 80px
                        >span
                            line-height 24px
                            font-size 12px
                            color var(--text-color-primary)
                            margin-right 10px
                .QRCode-shortbox
                    width 26%
                    .QRCode-imgbox
                        width 142px
                        height 142px
                        border 1px solid $box-bordercolor
                        border-radius: $box-radius;
                        overflow: hidden;
                        img
                            width 100%
                            height 100%
                            object-fit contain
                      .QRCode-importbtn
                        margin 0 auto
                        margin-top: 2px
                        width 90px
                        height 24px
                        line-height 22px
                        text-align center
                        color var(--text-color-primary)
                        font-size 12px
                        cursor pointer
                        user-select none
                        white-space nowrap
                        overflow hidden
                        border: 1px solid var(--border-color-box-6);
                        box-shadow: 0px 1px 0px var(--color-black-8);
                        border-radius: 6px;
                        text-overflow ellipsis
                        transition border-color .1s linear
                        border-radius: $box-radius;
                        &:hover{
                          background-color var(--themeColor);
                          border-color: var(--themeColor);
                          color:white;
                        }
        .dialog-slot
            @media screen and (max-height: 768px)
                overflow-y inherit
</style>

<template>
    <div class="QRCode-mask">
        <Dialog class="QRCode-modal" :title="$t('QRCode')" :isShow="true" @close="closeModal">
            <div class="QRCode-container">
                <!-- <div> -->
                <div class="QRCode-box QRCode-logbox">
                    <p class="QRCode-title">{{ $t("urlTitle") }}</p>
                    <Input
                        class="QRCode-inputArea"
                        v-model="enterURL"
                        type="textarea"
                        :rows="4"
                        :placeholder="URL"
                        :maxlength="200"
                        @on-keyup="setData()"
                    />
                    <div class="QRCode-count">{{ `${enterURL.length}/200` }}</div>
                </div>
                <div class="QRCode-box QRCode-shortbox">
                    <p class="QRCode-title"></p>
                    <div class="QRCode-imgbox">
                        <img :src="showQRCodeData" />
                    </div>
                </div>
                <!-- </div>
                <div> -->
                <div class="QRCode-box QRCode-logbox">
                    <p class="QRCode-title">{{ $t("moreSetting") }}</p>
                    <div class="QRCode-inputbox">
                        <span>{{ $t("margin") }}:</span>
                        <InputNumber
                            style="width: 80px"
                            size="small"
                            :min="0"
                            :max="25"
                            :formatter="(value) => `${value} px`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            v-model="QRCodeMargin"
                            @on-focus="editLocker('focus', 'lock')"
                            @on-blur="
                                editLocker('blur', 'lock', () => {
                                    setData();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lock', () => {
                                    setData();
                                })
                            "
                        />
                    </div>
                    <div class="QRCode-inputbox">
                        <span>{{ $t("quality") }}:</span>
                        <i-select class="QRCode-selector" size="small" v-model="QRCodeQuality" @on-change="setData()" :transfer="true">
                            <i-option v-for="item in qualityList" :value="item.value" :label="$t(item.text)" :key="item.id">
                                {{ $t(item.text) }}
                            </i-option>
                        </i-select>
                    </div>
                </div>
                <div class="QRCode-box QRCode-shortbox">
                    <p class="QRCode-title"></p>
                    <div class="QRCode-importbtn" v-if="!isLogo" @click="selectImg()" :title="$t('import')">{{ $t("import") }}</div>
                    <div class="QRCode-importbtn" v-else @click="removeImg()" :title="$t('remove')">{{ $t("remove") }}</div>
                    <input ref="importFile" type="file" accept=".jpg,.png,.jpeg" style="display: none" @change="getImg($event)" />
                </div>

                <!-- </div> -->
            </div>
            <div class="dialog-btnbox-normal">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    import { addJs } from "@/public/utils/tool";
    declare var QRCode: any;
    declare var qrcode: any;
    @Component({
        components: {
            Dialog,
        },
    })
    export default class InsertQRCode extends Vue {
        @Inject()
        ["showMessage"];

        enterURL: string = window.EDCONFIG.IS_SDK ? "https://www.edraw.ai/" : "https://www.edrawmax.cn/";
        get URL() {
            if (this.enterURL == "") {
                let string = this.internal ? "https://www.edrawmax.cn/" : "https://www.edrawmax.com/";
                if (window.EDCONFIG.IS_SDK) {
                    return "https://www.edraw.ai/";
                }
                return string;
            } else {
                return this.enterURL;
            }
        }
        QRCodeMargin: number = 10;
        QRCodeQuality: string = "Q";
        lock: boolean = false;
        isLogo: boolean = false;
        imgFile: any;
        QRCodeData: any;
        showQRCodeData: any = "";
        qualityList: Array<object> = [
            {
                id: 0,
                value: "L",
                text: "lowest",
            },
            {
                id: 1,
                value: "M",
                text: "low",
            },
            {
                id: 2,
                value: "Q",
                text: "medium",
            },
            {
                id: 3,
                value: "H",
                text: "high",
            },
        ];
        QRCodeSize = 0;
        QRCodeScale = 2;
        // qrcode 相关
        create_qrcode(text) {
            qrcode.stringToBytes = qrcode.stringToBytesFuncs["UTF-8"];

            let qr = qrcode(0, this.QRCodeQuality);
            qr.addData(text, "Byte");
            qr.make();

            //  return qr.createTableTag();
            //  return qr.createSvgTag();
            return qr.createSvgTag(2, 0);
        }
        createQRCode() {
            // 根据网址创建二维码
            if (this.URL == "") return;
            // let option  = {
            //     text: this.URL,
            //     width: 140,
            //     height: 140,
            //     colorDark: "#282828",
            //     colorLight: "#ffffff",
            //     correctLevel: QRCode.CorrectLevel[this.QRCodeQuality]
            // }
            // let div = document.createElement('div')
            // new QRCode(div, option);
            // this.QRCodeData = (div.children[0] as HTMLCanvasElement).toDataURL("image/png");

            this.QRCodeData = "data:image/svg+xml;utf8," + this.create_qrcode(this.URL);
            this.addLogoToQRCode().then((e) => {
                this.addMargin().then((e) => {
                    console.log("over");
                    this.showQRCodeData = this.QRCodeData;
                });
            });
        }
        addMargin() {
            // 在基础二维码基础上增加margin
            return new Promise((res) => {
                if (this.QRCodeMargin >= 0) {
                    let canvas = document.createElement("canvas");
                    let width = this.QRCodeSize - this.QRCodeMargin * 2;
                    canvas.width = this.QRCodeSize;
                    canvas.height = this.QRCodeSize;
                    let ctx = canvas.getContext("2d");
                    let img = new Image();

                    img.src = this.QRCodeData;
                    img.onload = () => {
                        ctx.fillStyle = "white";
                        ctx.fillRect(0, 0, this.QRCodeSize, this.QRCodeSize);
                        ctx.drawImage(img, this.QRCodeMargin, this.QRCodeMargin, width, width);
                        this.QRCodeData = canvas.toDataURL("image/png");
                        res();
                    };
                } else {
                    res();
                }
            });
        }
        addLogoToQRCode() {
            // 在基础二维码上增加logo
            return new Promise((res) => {
                if (this.isLogo) {
                    let canvas = document.createElement("canvas");
                    canvas.width = this.QRCodeSize;
                    canvas.height = this.QRCodeSize;
                    let ctx = canvas.getContext("2d");
                    let qrcode = new Image();
                    let logo = new Image();
                    logo.src = this.imgFile;
                    qrcode.src = this.QRCodeData;
                    let a = new Promise((s, j) => {
                        logo.onload = () => {
                            s();
                        };
                    });
                    let b = new Promise((s, j) => {
                        qrcode.onload = () => {
                            s();
                        };
                    });
                    Promise.all([a, b]).then((e) => {
                        ctx.drawImage(qrcode, 0, 0, this.QRCodeSize, this.QRCodeSize);
                        let sx, sy, sw, sh;
                        sx = sy = 52 * this.QRCodeScale;
                        sw = sh = 35 * this.QRCodeScale;
                        ctx.drawImage(logo, sx, sy, sw, sh);
                        this.QRCodeData = canvas.toDataURL("image/png");
                        res();
                    });
                } else {
                    res();
                }
            });
        }
        setData() {
            this.createQRCode();
        }

        selectImg() {
            if (!this.URL) {
                let msg = this.$t("noURL");
                this.showMessage({
                    type: 2,
                    time: 1,
                    content: msg,
                });
                return;
            }
            (this.$refs.importFile as HTMLInputElement).click();
        }
        removeImg() {
            // 移除logo
            this.isLogo = false;
            this.createQRCode();
        }
        getImg(e) {
            // 读取图片，增加logo到二维码
            let img = e.target.files[0];
            let reader = new FileReader();
            reader.onload = (ev) => {
                this.imgFile = reader.result;
                this.isLogo = true;
                this.createQRCode();
            };
            reader.readAsDataURL(img);
            e.target.value = "";
        }

        dataURLtoFile(dataurl, fileName) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], fileName, {
                type: mime,
                lastModified: Number(new Date()),
            });
            // let blob = new Blob([u8arr], { type: mime });
            // blob['lastModifiedDate'] = new Date();
            // blob['name'] = fileName;
            // return blob;
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        clearData() {
            this.QRCodeMargin = 0;
            this.QRCodeData = "";
            this.showQRCodeData = "";
        }
        confirm() {
            if (!this.URL) {
                let msg = this.$t("noURL");
                this.showMessage({
                    type: 2,
                    time: 1,
                    content: msg,
                });
                return;
            }
            if (!this.showQRCodeData) return;

            let view = window["_view"];
            let data = this.dataURLtoFile(this.showQRCodeData, "qrcode.png");
            this.sensors.track("insertQRCode", {
                Catalogues: "SpecificFunctions",
            });
            view.insertQRCodeScale(data, data.name, 1 / this.QRCodeScale);
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        mounted() {
            this.QRCodeSize = this.QRCodeScale * 140;
            if ((<any>window).qrcode) {
                this.setData();
            }
        }

        created() {
            if (!(<any>window).qrcode) {
                addJs("js/3rd/qrcode.min.js", this.setData);
            }
        }
    }
</script>
<i18n>
{
  "zh": {
    "QRCode": "插入二维码",
    "urlTitle": "网址",
    "moreSetting": "更多设置",
    "insertLogo": "插入logo",
    "margin": "边界",
    "quality": "质量",
    "import": "上传LOGO",
    "remove": "移除LOGO",
    "lowest": "差",
    "low": "较差",
    "medium": "中等",
    "high": "较好",
    "confirm": "确定",
    "cancel": "取消",
    "noURL": "请先输入网址"
  },
  "en": {
    "QRCode": "Insert QR Code",
    "urlTitle": "Web Link",
    "moreSetting": "More Settings",
    "insertLogo": "Insert Logo",
    "margin": "Margin",
    "quality": "Quality",
    "import": "Upload Logo",
    "remove": "Remove Logo",
    "lowest": "Very Low",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "confirm": "Insert",
    "cancel": "Cancel",
    "noURL": "Please enter URL"
  },
  "fr": {
    "QRCode": "Insérer Code QR",
    "urlTitle": "Lien Web",
    "moreSetting": "Plus de Paramètres",
    "insertLogo": "Insérer Logo",
    "margin": "Marge",
    "quality": "Tolérance aux pannes",
    "import": "Télécharger Logo",
    "remove": "Supprimer Logo",
    "lowest": "Pauvre",
    "low": "Pire",
    "medium": "Moyen",
    "high": "Mieux",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "noURL": "Veuillez entrer URL"
  },
  "de": {
    "QRCode": "QR Kode einfügen ",
    "urlTitle": "Webseite",
    "moreSetting": "Weitere Einstellungen",
    "insertLogo": "LOGO einfügen",
    "margin": "Seitenrand",
    "quality": "Qualität",
    "import": "Logo hochladen",
    "remove": "Logo entfernen",
    "lowest": "Niedrigste",
    "low": "Niedrig",
    "medium": "Medium",
    "high": "Hoch",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "noURL": "Bitte URL hinterlegen"
  },
  "jp": {
    "QRCode": "QRコードを挿入",
    "urlTitle": "インターネットアドレス",
    "moreSetting": "他の設定",
    "insertLogo": "ロゴを挿入",
    "margin": "余白",
    "quality": "誤り訂正レベル",
    "import": "ロゴをインポート",
    "remove": "ロゴを削除",
    "lowest": "L",
    "low": "M",
    "medium": "Q",
    "high": "H",
    "confirm": "OK",
    "cancel": "キャンセル",
    "noURL": "URLを入力してください"
  },
  "es": {
    "QRCode": "Insertar código QR",
    "urlTitle": "Enlace web",
    "moreSetting": "Más Ajustes",
    "insertLogo": "Insertar Logo",
    "margin": "Margen",
    "quality": "Calidad",
    "import": "Subir logotipo",
    "remove": "Quitar el logotipo",
    "lowest": "Muy bajo",
    "low": "Bajo",
    "medium": "Medio",
    "high": "Alto",
    "confirm": "Insertar",
    "cancel": "Cancelar",
    "noURL": "Por favor, introduzca el URL"
  },
  "pt": {
    "QRCode": "Inserir Código QR",
    "urlTitle": "Web Link",
    "moreSetting": "Mais Configurações",
    "insertLogo": "Inserir Logo",
    "margin": "Limite",
    "quality": "Qualidade",
    "import": "Carregar Logo",
    "remove": "Remover Logo",
    "lowest": "Muito Baixo",
    "low": "Baixo",
    "medium": "Médio",
    "high": "Alto",
    "confirm": "Inserir",
    "cancel": "Cancelar",
    "noURL": "Por favor, inserir URL"
  },
  "it": {
    "QRCode": "Inserisci Codice QR",
    "urlTitle": "Collegamento Web",
    "moreSetting": "Altre Impostazioni",
    "insertLogo": "Inserisci Logo",
    "margin": "Margine",
    "quality": "Qualità",
    "import": "Carica Logo",
    "remove": "Rimuovi Logo",
    "lowest": "Molto Bassa",
    "low": "Bassa",
    "medium": "Media",
    "high": "Alta",
    "confirm": "Inserisci",
    "cancel": "Annulla",
    "noURL": "Si prega di immettere una URL."
  },
  "tw": {
    "QRCode": "插入二維碼",
    "urlTitle": "網址",
    "moreSetting": "更多設置",
    "insertLogo": "插入logo",
    "margin": "邊界",
    "quality": "容錯",
    "import": "上傳LOGO",
    "remove": "移除LOGO",
    "lowest": "差",
    "low": "較差",
    "medium": "中等",
    "high": "較好",
    "confirm": "確定",
    "cancel": "取消",
    "noURL": "請輸入網址"
  },
  "kr": {
    "QRCode": "QR 코드 삽입",
    "urlTitle": "웹 링크",
    "moreSetting": "더 많은 설정",
    "insertLogo": "로고 삽입",
    "margin": "여백",
    "quality": "품질",
    "import": "로고 업로드",
    "remove": "로고 제거",
    "lowest": "매우 낮음",
    "low": "낮음",
    "medium": "중간",
    "high": "높음",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "noURL": "URL을 입력하세요"
  }
}
</i18n>
